import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "../assets/styles/Timeline.scss";
import { education } from "../constants/constants";

function Education() {
  return (
    <div id="education" className="bg-gray-50 py-12">
      <div className="items-container max-w-6xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12 text-indigo-800">
          Education
        </h1>
        <VerticalTimeline layout="1-column-left">
          {education.map((experience, index) => (
            <VerticalTimelineElement
              key={index}
              className="vertical-timeline-element--education"
              contentStyle={{
                background: "white",
                color: "#2d3748",
                boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                borderRadius: "12px",
                borderLeft: "4px solid #48bb78",
              }}
              contentArrowStyle={{ borderRight: "10px solid white" }}
              date={experience.date}
              dateClassName="text-xl md:text-2xl font-bold text-gray-700"
              iconStyle={{
                background: "#68d391", // Light green
                color: "#fff",
                boxShadow:
                  "0 0 0 4px #fff, inset 0 2px 0 rgba(0,0,0,.08), 0 3px 0 4px rgba(0,0,0,.05)",
              }}
              icon={<FontAwesomeIcon icon={faGraduationCap} />}
            >
              <div className="space-y-3">
                <h3 className="text-2xl font-bold text-indigo-700">
                  {experience.title}
                </h3>
                <h4 className="text-xl font-semibold text-gray-600">
                  {experience.subtitle}
                </h4>
                <ul className="space-y-2 list-disc pl-5 text-gray-700">
                  {experience.description.map((desc, i) => (
                    <li
                      key={i}
                      className="text-base leading-relaxed"
                      dangerouslySetInnerHTML={{ __html: desc }}
                    />
                  ))}
                </ul>
              </div>
            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Education;
